// src/utils/paymentAmount.js
//
// Shared amount-randomization logic used by BOTH Register.js and
// PaymentPage.js, so the two screens can never disagree on the figure
// shown to the user. Register.js generates the amount once and passes it
// through the URL to PaymentPage.js — this file just holds the one
// function both places call.

export const NG_BASE_AMOUNT = 10200;
export const GH_BASE_AMOUNT = 120;

// Generates a random amount from base up to base+200, in steps of 50 —
// e.g. for NG: 10200, 10250, 10300, 10350, or 10400. Exists so
// Flutterwave never sees the exact same registration amount repeated
// across different senders (which can trigger fraud flagging), while
// still landing on a clean, real-looking price point rather than an
// obviously-randomized number.
export const generateVariedAmount = (base) => {
  const steps = [0, 50, 100, 150, 200];
  const randomStep = steps[Math.floor(Math.random() * steps.length)];
  return base + randomStep;
};
